// extracted by mini-css-extract-plugin
export var container = "_4k-0";
export var fallback = "_4k-5";
export var fallbackIcon = "_4k-6";
export var hidden = "_4k-2";
export var image = "_4k-3";
export var loaded = "_4k-4";
export var placeholder = "_4k-1";